import React, { useEffect, useRef, useState } from 'react';
import './blogpreview.scss';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Hexapi from '../usefulcomps/HexAPI/Hexapi';
import { useNavigate, useParams } from 'react-router-dom';
import { Modal, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import ScrollToTop from '../ScrollToTop';

const Blogpreview = () => {
    const { BlogID } = useParams();
    const navigate = useNavigate();
    const [singledata, setsingledata] = useState([]);
    const [showLoading, setshowLoading] = useState(true);
    const fetchblogsingledata = async () => {
        const obj={
            'query':`[dbo].[Seetech_Web_Proc_Blog_GetData]
            @BlogID ='{0}'`,
            'queryArr':[`${BlogID}`]
         }

        try {
            const singleblog = await Hexapi(obj);
            setshowLoading(false)
            setsingledata(singleblog[""]);
            document.title = singleblog[""][0].title;
            console.log(singleblog,"blog resp")
            console.log(document.description = singleblog[""][0].shortdesciption,"Check description")
            const shortDescription = singleblog[""][0].shortdesciption
            let metaDesc = document.querySelector('meta[name="description"]');
             if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = "description";
        document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute("content", shortDescription);
        } catch (error) {
            console.log(error, "error");
            setshowLoading(false);
        }
    };

    useEffect(() => {
        fetchblogsingledata();
    }, [BlogID]);

    const handleBackClick = () => {
        navigate("/blog");
    };

    return (
        <>
        <ScrollToTop/>
         <Helmet>
                <link rel="canonical" href={`https://seetechparts.com/blog/${singledata[0]?.urlslug}`} />
              </Helmet>
            {showLoading ?
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '10%', color: 'rgb(235 197 137)', minHeight: '400px' }}>
              <h3>
                <Spinner animation='border' style={{ color: '#f9b101' }} />
              </h3>
            </div> : (
                <div className="blogpreview-root">
                    <div className="container">
                        <button className='blogpreview-back-btn  align-items-center' onClick={handleBackClick}>
                            <ArrowBackIcon style={{ cursor: 'pointer' }} /> Back
                        </button>

                        <div className='blogpreview-card col-lg-12'>
                            <div className="blogpreview-body">
                                <h1>{singledata[0]?.title}</h1>
                                <div className="blogpreview-img-div">
                                    <img src={`${sessionStorage.getItem('Apipathurl')}${singledata[0]?.imagepath}`} alt={singledata[0]?.imagealttext} />
                                </div>
                                <div  className=' setli' dangerouslySetInnerHTML={{ __html: singledata[0]?.body }} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Blogpreview;
